import { getListTour } from "../../data/repository/tourRepo";

export const getListTourUseCase = async () => {
  const response = await getListTour();
  return response;
};
